/**
 * Shared invoice / receipt verbiage. Used for Stripe checkout descriptions and
 * metadata, and for the on-screen receipt summary, so accounting sees the exact
 * same wording everywhere.
 */

import {
  CREDIT_EXPIRY_NOTICE,
  formatUsd,
  planForPriceId,
  type PlanDefinition,
} from "./billing-plans";

/** e.g. "Easements.com Team — $250/mo, 250 reports included, $2 per additional report." */
export function subscriptionReceiptLine(plan: PlanDefinition): string {
  return `Easements.com ${plan.name}: ${formatUsd(plan.monthlyCents)}/mo, ${plan.included} reports included, ${formatUsd(plan.overageCents)} per additional report. Included reports reset each month; purchased credits never expire.`;
}

export function subscriptionReceiptLineFor(priceId: string): string {
  return subscriptionReceiptLine(planForPriceId(priceId));
}

/** e.g. "Easements.com additional property reports — 10 reports at $2.00 each." */
export function overageReceiptLine(quantity: number, perReportCents: number): string {
  const each = `$${(perReportCents / 100).toFixed(2)}`;
  const noun = quantity === 1 ? "report" : "reports";
  return `Easements.com additional property reports: ${quantity} ${noun} at ${each} each.`;
}

export function overageTotalCents(quantity: number, perReportCents: number): number {
  return Math.max(0, Math.round(quantity * perReportCents));
}

export { CREDIT_EXPIRY_NOTICE };
